import type { SyntheticEvent } from "react";

export const submitForm = (form: { handleSubmit: () => unknown }) => (event: SyntheticEvent) => {
  event.preventDefault();
  event.stopPropagation();
  void form.handleSubmit();
};
